import emergence from 'emergence.js/dist/emergence.min.js';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // hide/open collapse menu's on mobile in footer
    $(window).on('load ready', function () {
      if ($(window).width() > 768) { // md
        $('.js-collapse-footer .collapse').addClass('show');
      } else {
        $('.js-collapse-footer .collapse').removeClass('show');
      }
    });

    emergence.init({
      container: window,
      reset: false,
      handheld: true,
      throttle: 250,
      elemCushion: 0.15,
      offsetTop: 200,
      offsetRight: 0,
      offsetBottom: 0,
      offsetLeft: 0,
    });

    if ($(window).width() > 768) {
      $('.paroller-sm').paroller({ factor: 0.05, type: 'foreground', direction: 'vertical' });
      $('.paroller').paroller({ factor: 0.1, type: 'foreground', direction: 'vertical' });
      $('.paroller-negative').paroller({ factor: -0.05, type: 'foreground', direction: 'vertical' });
    }

    // Change modal content when opening modal
    $('#modal').on('show.bs.modal', function(e) {
      var button = $(e.relatedTarget);
      var title = button.data('title') ? button.data('title') : '';
      var content = JSON.parse(button.data('content'));
      var modal = $(this);
      modal.find('.modal-header').prepend('<h5 class="modal-title" id="modalLabel">' + title + '</h5>');
      modal.find('.modal-body').html(content);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'UAevent',
        'eventCategory': 'modalopen',
        'eventAction': title,
        'eventLabel': window.location.href, 
        'eventValue': undefined,
      });
    });

    // Remove modal content after its hidden
    $('#modal').on('hidden.bs.modal', function() {
      var modal = $(this);
      modal.find('.modal-title').remove();
      modal.find('.modal-body').html('');
    });

    $('.pn__items a').click(function() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'UAevent',
        'eventCategory': 'menuclick',
        'eventAction': 'depth' + $(this).data('depth') + ': ' + $(this).attr('href'),
        'eventLabel': window.location.href,
        'eventValue': undefined,
      });
    });
    
    // Smooth scroll anchor link desktop
    $('a[href="#product_specifications"]').click(function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $(this.hash).offset().top - 50,
      }, 500);
    });

    // Smooth scroll anchor link mobile
    $('a[href="#product_specifications-mobile"]').click(function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $(this.hash).offset().top - 25,
      }, 500);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js